export const environment = {
  production: false,
  hostUrl: 'https://kpwdiscount.com/',
  apiUrl: 'https://kpwdiscount.com/api/',
};
